import type { ListingUnreadMessageCount } from '@/api/flatfox';
import type { LatestImportResponse } from '@/api/importReport';
import type { UserData } from '@/components/Agency/UserFormData/types';
import type { AccountOwner, AgencyDetails, AgencyProduct } from '@/types-agency';

export interface AgencyState {
  activeAgencyId?: string;
  agencies: AgencyDetails[];
  activeProducts: AgencyProduct[];
  usersForActiveAgency: UserData[];
  isBillToAgency: boolean;
  isImmoCreditsCustomer: boolean;
  bcsOwner?: AccountOwner;
  flatfoxListingUnreadMessageCounts: ListingUnreadMessageCount[];
  flatfoxTotalUnreadMessageCount: number | null;
  importSummary: LatestImportResponse | null;
}

export interface AgencyUserMfaOptions {
  userId: string;
  requiredMFA: boolean;
}

export const BCS_OWNER_FALLBACK: AccountOwner = {
  email: 'customerservice-re@swissmarketplace.group',
  ownerName: '',
  phone: '+41 58 900 73 08',
};

export function getInitialAgencyState(): AgencyState {
  return {
    activeAgencyId: undefined,
    agencies: [],
    activeProducts: [],
    usersForActiveAgency: [],
    isBillToAgency: false,
    isImmoCreditsCustomer: false,
    bcsOwner: {
      email: '',
      ownerName: '',
      phone: '',
    },
    flatfoxListingUnreadMessageCounts: [],
    flatfoxTotalUnreadMessageCount: null,
    importSummary: null,
  };
}
